import { QueryClientProvider } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/contexts/AuthContext";
import { FeatureFlagsProvider } from "@/contexts/FeatureFlagsContext";
import { queryClient } from "@/integrations/queryClient";
import { RouterStackProvider } from "@/router";
import FallbackComponent from "@/components/Fallback";

export default function App() {
  return (
    <Sentry.ErrorBoundary showDialog fallback={<FallbackComponent />}>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <AuthProvider>
            <FeatureFlagsProvider>
              <RouterStackProvider />
              <Toaster />
              <Sonner />
            </FeatureFlagsProvider>
          </AuthProvider>
        </TooltipProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  );
}
